<template>
  <AssetLogStyled>
    <AssetInfoStyled>
      <table class="column">
        <tr class="row">
          <td class="label">{{ $tc('lastUpdate', 1) }}</td>
          <td class="value">
            <TimeAgo :time="assetLastUpdate" />
          </td>
        </tr>
      </table>
    </AssetInfoStyled>
    <ErrorLog :isWidget="false" :assetID="assetID" :assetLastUpdate="assetLastUpdate" />
  </AssetLogStyled>
</template>

<script>
import { styled } from '@egoist/vue-emotion'
import ErrorLog from '@/components/Widgets/ErrorLog'
import get from 'lodash/get'
import { TimeAgo } from '@common/components'
import ASSET_QUERY from '#/graphql/operations/asset/assetWithLastPosition.gql'

const AssetLogStyled = styled('div')`
  height: 100%;
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: 1fr;
  grid-auto-rows: min-content 1fr;
`
const AssetInfoStyled = styled('div')`
  padding: 1rem;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.atomic.tableBG};
  border-radius: 0.5rem;
  .column {
    display: table;
    width: 100%;
    .row {
      margin-top: 0.5rem;
      .label {
        text-align: left;
        color: ${({ theme }) => (theme.isDark ? theme.colors.muted : theme.colors.dimGrey)};
        width: 1%;
        white-space: nowrap;
        padding-right: 20px;
        @media (max-width: 768px) {
          word-break: break-word;
        }
      }
      .value {
        margin-left: 0.5rem;
        flex-grow: 1;
        word-break: break-word;
      }
    }
  }
`

export default {
  components: {
    AssetLogStyled,
    ErrorLog,
    AssetInfoStyled,
    TimeAgo,
  },
  data() {
    return {
      asset: null,
    }
  },
  computed: {
    assetID() {
      return get(this.$route, 'params.id', null)
    },
    assetLastUpdate() {
      return get(this.asset, 'lastLog', null)
    },
  },
  apollo: {
    asset: {
      query: ASSET_QUERY,
      variables() {
        return {
          id: this.assetID,
        }
      },
      skip() {
        return !this.assetID
      },
    },
  },
}
</script>
